import { useEffect, useRef, useState } from "react";
import Button, { ButtonSquare } from "../../../components/design/buttons/Button";
// import './Payment.css'
import { Card, Collapse, Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import React from "react";
import { REACT_APP_API_ESIM, REACT_APP_API_PAYMENT, REACT_APP_API_PAYMENTS } from '../../../../config';
import axios from "axios";
import { handleDataLayer } from "../../../tools/AssetHelpers";
import { planToItem, trackAddPaymentInfo } from "../../../tools/tracking";
import { ObjectArray } from "../Page";
import { checkout, generateCheckoutId } from "../../../services/sim.service";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { BiQrScan } from "react-icons/bi";
import { hasNativeApplePay } from "../../../tools/applePay";

// The gateway widget is mounted into these, one per card. React renders them
// empty and never puts a child inside: COPYandPAY replaces and reparents the
// nodes it binds to, and React then cannot reconcile DOM it no longer
// recognises — that is the NotFoundError on removeChild.
const WIDGET_HOSTS: { [method: string]: string } = {
    APPLEPAY: "paymentWidgets_apple",
    VISA: "paymentWidgets_visa",
    STC_PAY: "paymentWidgets_stc",
};

const WIDGET_BRANDS: { [method: string]: string } = {
    APPLEPAY: "APPLEPAY",
    VISA: "VISA MASTER",
    STC_PAY: "STC_PAY",
};

// STC_PAY is a HyperPay *brand* paid through the card entity, not a backend
// entity type of its own — the order service only knows VISA / APPLEPAY, and
// sending "STC_PAY" is rejected. Map it for everything that leaves for the
// backend: the checkout body, and the entityType the result url carries into
// CheckoutConfirm. The raw method is still what the UI and analytics use.
const entityTypeFor = (method: string) => (method === "STC_PAY" ? "VISA" : method);

const Payment: React.FC<ObjectArray> = ({ onOptionSelect, t, i18n, objs }) => {
    // const [selected, setSelected] = useState(0);
    const navigate = useNavigate();
    // const [state, setState] = useState<any>("register");
    const isMobile = window.innerWidth < 992;
    const total = objs?.fees?.find((f: any) => f.type === 4)
        ? Number(objs.fees.find((f: any) => f.type === 4).value).toFixed(2)
        : (objs?.plan?.price * (1 - (objs?.plan?.discountRate || 0))).toFixed(2);
    // const [plan, setPlan] = React.useState<any>(null);
    const [user, setUser] = useState<any>(localStorage.getItem("tygo_user"));
    const [loading, setLoading] = useState<boolean>(false);
    // Keyed by entity type, not by card. STC_PAY is created as a VISA checkout
    // (see entityTypeFor), so the card and the STC_PAY card share one checkout id
    // and one transaction id: selecting STC_PAY after the card reuses the checkout
    // already generated instead of asking the backend for an identical second one.
    const [checkoutIds, setCheckoutIds] = useState<any>({
        'VISA': "",
        'APPLEPAY': "",
    });

    const [transactionIds, setTransactionIds] = useState<any>({
        'VISA': "",
        'APPLEPAY': "",
    });
    // Apple Pay is offered in every browser: where there is no ApplePaySession the
    // gateway widget renders nothing, so the card falls back to the QR handoff
    // instead (see the APPLEPAY collapse below). It is only *preselected* where it
    // can be paid natively — Safari opens on Apple Pay, Chrome and the rest open on
    // the card form rather than on a QR the shopper has to reach for a phone to use.
    const [nativeApplePay] = useState<boolean>(hasNativeApplePay);
    const [paymentMethod, setPaymentMethod] = useState<string>(nativeApplePay ? "APPLEPAY" : "VISA");
    // Which checkout the selected card is paid against — VISA and STC_PAY share one.
    const checkoutKey = entityTypeFor(paymentMethod);
    const [show, setShow] = useState<boolean>(false);
    const [showCancel, setShowCancel] = useState<boolean>(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
    const [countdown, setCountdown] = useState<number>(30);

    var wpwlOptions = {
        locale: "ar",
        applePay: {
            displayName: "Tygo",
            total: { label: "Tygo" },
        }
    };

    useEffect(() => {
        setUser(localStorage.getItem("tygo_user"));
        if (user && JSON.parse(user).token) {
            handleDataLayer("payment_page", "user", "user_visited_payment_page", "user_visited_payment_page");
        } else {
            handleDataLayer("login_page", "user", "user_visited_login_page", "user_visited_login_page");
        }

        const interval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    setIsButtonDisabled(false);
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    // One checkout id per entity type, kept in a ref so it survives a re-render
    // as well as StrictMode's double effect invocation: two overlapping calls both
    // see an empty checkoutIds[key], and every id that comes back loads its own
    // copy of the gateway widget — which is what renders a second payment card.
    const checkoutRequests = useRef<{ [entityType: string]: Promise<any> }>({});

    const GenerateCheckoutId = (method: string): Promise<any> => {
        const key = entityTypeFor(method);
        const pending = checkoutRequests.current[key];
        if (pending) return pending;

        setLoading(true);
        console.log(objs);

        // const body = {
        //     "email": (objs?.email || ""),
        //     "street": (objs?.street || ""),
        //     "city": (objs?.city || ""),
        //     "state": (objs?.state || ""),
        //     "country": (objs?.country || ""),
        //     "postcode": (objs?.postcode || ""),
        //     "givenName": (objs?.name || "").replace(/\s/g, ''),
        //     "surname": (objs?.surname || ""),
        //     "phoneNumber": (objs?.phoneNumber || ""),
        //     "countryCode": (objs?.countryCode || ""),
        //     "amount": (objs?.plan?.price || 0),
        //     "entityType": paymentMethod,
        //     "userId": (user ? user.userId : ""),
        //     "paymentFor": "string",
        //     "productIds": ((objs?.plan_id).toString() || ""),
        //     "productNames": (objs?.plan?.name || ""),
        //     "tygoOrderId": (objs?.plan?.id || "").toString(),
        //     "promoCode": "",
        //     "deviceType": "string",
        //     "deviceVersion": "string"
        // }
        const user_ = JSON.parse(localStorage.getItem("tygo_user") || "");

        const body1 = {
            "productIds": objs?.plan.id.toString(),
            "productNames": (objs?.plan?.name || ""),
            "tygoOrderId": objs?.tygoOrderId,
            "email": (objs?.email || ""),
            "productId": objs?.plan.id,
            "street": "12345",
            "city": "Rhiyad",
            "postcode": "21777",
            "state": "Rhiyad",
            "country": "SA",
            "givenName": (objs?.name || "").replace(/\s/g, ''),
            "surname": (objs?.surname || ""),
            "phoneNumber": (objs?.number || ""),
            "countryCode": (objs?.selectedCode || ""),
            //only 2 digets after comma
            "amount": total,
            "entityType": entityTypeFor(method),
            "userId": (user_ ? user_.userId : ""),
            "paymentFor": null,
            "promoCode": "",
            "planId": objs?.plan.id,
            "agentId": objs?.agentId ? objs?.agentId : null,
            "plan_id": objs?.plan_id,
        }

        const request = (async () => {
            const response = await generateCheckoutId(body1, objs.providerId);

            // `total` is the fee-type-4 grand total, i.e. what is actually charged
            // (plan price + one-time service fee) — not the plan price alone.
            // Snapshotted here because /sim/order/create lands after a full-page
            // gateway redirect with nothing but URL params.
            trackAddPaymentInfo({
                transactionId: objs?.tygoOrderId,
                value: Number(total),
                items: [planToItem(objs?.plan, { provider: objs?.provider })],
                paymentType: method,
            });

            console.log(response);
            // New objects, so the widget effect and the QR url actually see the id
            // land — mutating the held state in place changes nothing React can
            // react to, and `key` is the entity type being generated (paymentMethod
            // may be a different card whenever this runs for the QR handoff).
            setCheckoutIds((prev: any) => ({ ...prev, [key]: response.hyperpayCheckoutId }));
            setTransactionIds((prev: any) => ({ ...prev, [key]: response.paymentTransactionId }));
            return response;
        })();

        checkoutRequests.current[key] = request;
        request
            // free the slot so a failed method can be retried
            .catch(() => { delete checkoutRequests.current[key]; })
            .then(() => setLoading(false));
        return request;
    };

    useEffect(() => {
        if (objs && paymentMethod) {
            if (checkoutIds[checkoutKey] && checkoutIds[checkoutKey] !== "") {
                console.log("Checkout ID already exists for payment method:", paymentMethod);
                return;
            }
            GenerateCheckoutId(paymentMethod);
        }
    }, [objs, paymentMethod]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCancel = () => {
        setShowCancel(false);
        navigate("/esims");
    }

    // Built by hand rather than rendered, so it can be dropped inside the widget's
    // own DOM without React owning a node the gateway will move.
    const buildTermsNode = () => {
        const terms = document.createElement("span");
        terms.className = "terms_ terms_for_card";
        terms.innerHTML =
            `${t("store.by_continuing")} ` +
            `<a class="m-0" href="https://tygo.sa/en/terms" target="_blank">${t("store.terms")}</a>` +
            ` ${t("store.and")} ` +
            `<a class="m-0" href="https://tygo.sa/en/privacy" target="_blank">${t("store.privacy_policy")}</a>.`;
        return terms;
    };

    // The widget paints asynchronously and gives no ready callback, so its pay
    // button and CVV label are polled for. Bounded and cancellable — the old
    // version recursed on a 1s timer forever whenever the selected method had no
    // .wpwl-button-pay (Apple Pay never has one).
    const decorateWidget = (cancelled: { current: boolean }) => {
        let attempts = 0;
        const tick = () => {
            if (cancelled.current || attempts++ > 30) return;

            const paymentButton = document.querySelector(".wpwl-button-pay");
            if (paymentButton?.parentNode && !document.querySelector(".terms_for_card")) {
                paymentButton.parentNode.insertBefore(buildTermsNode(), paymentButton);
            }

            const cvv_label = document.querySelector(".wpwl-label-cvv");
            if (cvv_label && !cvv_label.getAttribute("data-cvv-help")) {
                cvv_label.setAttribute("data-cvv-help", "true");
                cvv_label.addEventListener("click", handleShow);
                cvv_label.setAttribute("style", "cursor: pointer;");
            }

            if (!paymentButton || !cvv_label) setTimeout(tick, 1000);
        };
        setTimeout(tick, 1000);
    };
    // Where the gateway redirects once a checkout is paid, and where the "check
    // payment" buttons go by hand when no redirect arrives. Built for the method
    // that was actually paid rather than read off one shared piece of state: a QR
    // checkout is paid on another device, so nothing ever redirects this browser,
    // and the card left open here can be a different checkout entirely.
    const buildResultUrl = (method: string) => {
        const key = entityTypeFor(method);
        return window.location.origin + "/sim/order/create" +
            "?providerOrderId=" + objs?.providerOrderId +
            "&amount=" + total +
            "&providerCheckoutId=" + objs?.providerCheckoutId +
            "&tygoCheckoutId=" + checkoutIds[key] +
            "&tygoTransactionId=" + transactionIds[key] +
            "&paymentStatus=true" +
            "&date=" + new Date().toISOString() +
            "&tygoOrderId=" + objs?.tygoOrderId +
            "&entityType=" + key +
            "&providerId=" + objs?.providerId +
            "&planId=" + objs?.plan_id;
    };

    useEffect(() => {
        const checkoutId = checkoutIds[checkoutKey];
        if (!checkoutId) return;
        // Outside Safari the Apple Pay card shows our own QR handoff and has no
        // widget host, so there is nothing for the gateway script to paint.
        if (paymentMethod === "APPLEPAY" && !nativeApplePay) return;

        const host = document.getElementById(WIDGET_HOSTS[paymentMethod]);
        if (!host) return;

        const resultUrl = buildResultUrl(paymentMethod);

        // paymentWidgets.js walks document.forms and binds to the FIRST form
        // carrying the paymentWidgets class, whatever checkout id it was fetched
        // for. Only the selected method's form exists, so it always binds the right
        // card — and it is created here rather than rendered so that the action is
        // already the real result url on the first paint, not a state update behind.
        const form = document.createElement("form");
        form.setAttribute("action", resultUrl);
        form.className = "paymentWidgets";
        form.setAttribute("data-brands", WIDGET_BRANDS[paymentMethod]);
        host.innerHTML = "";
        host.appendChild(form);

        const script = document.createElement("script");
        script.src = `https://` + (REACT_APP_API_ESIM === "https://test.esim.tygo.net" ? "test." : "") + `oppwa.com/v1/paymentWidgets.js?checkoutId=${checkoutId}`;
        script.async = true;
        script.setAttribute("data-options", JSON.stringify(wpwlOptions));
        document.body.appendChild(script);

        const cancelled = { current: false };
        decorateWidget(cancelled);

        return () => {
            // COPYandPAY binds one checkout id and one brand set per script load,
            // so switching cards means tearing the widget down and loading it
            // again — even when the id itself is reused (VISA <-> STC_PAY).
            cancelled.current = true;
            try {
                (window as any).wpwl?.unload?.();
            } catch (e) {
                console.log("wpwl unload failed", e);
            }
            script.remove();
            host.innerHTML = "";
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkoutIds[checkoutKey], paymentMethod, nativeApplePay]);

    const [showQr, setShowQr] = useState<string>("");
    const handleCloseQr = () => setShowQr("");
    const [url, setUrl] = useState<string>("");
    useEffect(() => {
        const checkoutIdUpdate = async () => {
            if (showQr === "") return;
            let checkoutId = checkoutIds[entityTypeFor(showQr)];
            if (!checkoutId) {
                // read off the response: the state update for it only reaches this
                // closure on the next run of the effect
                const response = await GenerateCheckoutId(showQr);
                checkoutId = response?.hyperpayCheckoutId;
            }
            setUrl(
                `https://pay.tygo.net/v2/?checkoutId=${checkoutId}&ismobile=true&amount=${total}&locale=${i18n.language}&isApple=${showQr === "APPLEPAY" ? "true" : "false"}`
            );
        };
        checkoutIdUpdate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showQr, checkoutIds]);


    // Same target as the QR modal, but bound to the Apple Pay checkout id so the
    // card can show it inline for browsers that cannot render the native button.
    const applePayQrUrl = checkoutIds["APPLEPAY"]
        ? `https://pay.tygo.net/v2/?checkoutId=${checkoutIds["APPLEPAY"]}&ismobile=true&amount=${total}&locale=${i18n.language}&isApple=true`
        : "";

    const gotoShopperResultUrl = (method: string) => {
        setShowQr("");
        setLoading(true);
        window.location.href = buildResultUrl(method); // For web
    };

    // const url = (method: string) => {
    //     alert(method);
    //     return ;
    // }
    return (
        <div className="cko-payment-form" data-checkout-id={checkoutIds[checkoutKey]}>
            <>
                <div className={"card card_total"}>
                    <span>{t("store.total")}</span>
                    <span className="price_total">
                        {objs?.fees?.find((f: any) => f.type === 4)
                            ? Number(objs.fees.find((f: any) => f.type === 4).value).toFixed(2)
                            : objs?.plan?.price
                        } {t("global.sar")}
                    </span>
                </div>
                <div className="card mb-3"
                    onClick={() => setPaymentMethod("APPLEPAY")}>
                    <div className="header_card w-100 d-flex justify-content-between align-items-center">
                        <span className="big-text">
                            Pay
                        </span>
                        <span>
                            <BiQrScan className="mx-2" size={20} onClick={() => setShowQr("APPLEPAY")} />
                            {paymentMethod === "APPLEPAY" ?
                                <i className="fas fa-chevron-up mx-2"></i> :
                                <i className="fas fa-chevron-down mx-2"></i>
                            }
                        </span>
                    </div>
                    <Collapse in={paymentMethod === "APPLEPAY"}>
                        <div id="collapseAPPLEPAY">
                            <span className="terms_ terms_for_card_y">
                                <span>{t("store.by_continuing")} </span>
                                <span><a className="m-0" href="https://tygo.sa/en/terms" target="_blank">{t("store.terms")}</a></span>
                                <span> {t("store.and")} </span>
                                <span><a className="m-0" href="https://tygo.sa/en/privacy" target="_blank">{t("store.privacy_policy")}</a>.</span>
                            </span>
                            {nativeApplePay ? (
                                <div className="paymentMethod" id="paymentWidgets_apple"></div>
                            ) : (
                                <div className="d-flex flex-column align-items-center gap-3 py-3">
                                    {applePayQrUrl ? (
                                        <QRCodeSVG value={applePayQrUrl} size={200} />
                                    ) : (
                                        <Spinner animation="border" />
                                    )}
                                    <span className="text-center">{t("store.scan_apple_pay")}</span>
                                    {/* Paid on the phone, so the gateway never redirects
                                        this browser — same manual check as the QR modal. */}
                                    <ButtonSquare
                                        color="primary"
                                        isMargin={false}
                                        isDisabled={!applePayQrUrl}
                                        onClick={() => gotoShopperResultUrl("APPLEPAY")}
                                        inner={t("store.check_payment")}
                                    />
                                </div>
                            )}
                        </div>
                    </Collapse>
                </div>
                <div className="card mb-3" onClick={() => setPaymentMethod("VISA")}>
                    <div className="header_card w-100 d-flex justify-content-between align-items-center">
                        <span>{t("store.via_bank_card")}</span>
                        <span>
                            <BiQrScan className="mx-2" size={20} onClick={() => setShowQr("VISA")} />
                            {paymentMethod === "VISA" ?
                                <i className="fas fa-chevron-up mx-2"></i> :
                                <i className="fas fa-chevron-down mx-2"></i>
                            }
                        </span>


                    </div>
                    <Collapse in={paymentMethod === "VISA"}>
                        {/* one element, not a fragment: Collapse clones its child to
                            apply the collapse class and ref, and a fragment takes
                            neither — which left this card open whatever was selected */}
                        <div>
                            {/* the terms line is inserted above the widget's own pay
                                button once it paints — see decorateWidget */}
                            <div id="collapseVISA">
                                <div className="paymentMethod" id="paymentWidgets_visa"></div>
                            </div>
                            {/* if payment went seccussfuly but there is no redirection */}
                            <div className="d-flex justify-content-center align-items-center gap-2">
                                <span>{t("store.redirect_msg1")} {countdown} {t("store.redirect_msg2")}</span>
                                <Button
                                    color={isButtonDisabled ? "outline"
                                        : "primary-outline-primary"}
                                    isDisabled={isButtonDisabled}
                                    onClick={() => gotoShopperResultUrl(paymentMethod)}
                                    inner={t("store.check_payment")}
                                    size="sm"

                                />
                            </div>
                        </div>
                    </Collapse>
                </div>

                <div className="card mb-3" onClick={() => setPaymentMethod("STC_PAY")}>
                    <div className="header_card w-100 d-flex justify-content-between align-items-center">
                        <span>{t("store.via_stc")}</span>

                        <span>
                            <BiQrScan className="mx-2" size={20} onClick={() => setShowQr("STC_PAY")} />
                            {paymentMethod === "STC_PAY" ?
                                <i className="fas fa-chevron-up mx-2"></i> :
                                <i className="fas fa-chevron-down mx-2"></i>
                            }
                        </span>

                    </div>
                    <Collapse in={paymentMethod === "STC_PAY"}>
                        <div id="collapseSTC_PAY">
                            <div className="paymentMethod" id="paymentWidgets_stc"></div>
                        </div>
                    </Collapse>
                </div>
            </>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("store.cvv")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column">
                        <div className="d-flex justify-content-center align-items-center">
                            <img src="https://tygo.sa/images/cvv.png" alt="cvv" />
                        </div>
                        <div className="d-flex justify-content-center align-items-center">
                            <span>{t("store.cvv_desc")}</span>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showQr != ""} onHide={handleCloseQr}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("store.qr")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column gap-3">
                        {showQr && checkoutIds[entityTypeFor(showQr)] ? (
                            <div className="d-flex justify-content-center align-items-center">
                                <QRCodeSVG value={url} size={300} />
                            </div>
                        ) : (
                            <div className="d-flex justify-content-center align-items-center">
                                <Spinner animation="border" />
                            </div>
                        )}
                        <div className="d-flex justify-content-center align-items-center">
                            <span className="text-center">{t("store.scan_qr")}</span>
                        </div>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            <ButtonSquare
                                onClick={handleCloseQr}
                                inner={t("store.close")}
                            />
                            <ButtonSquare
                                color="primary"
                                onClick={() => gotoShopperResultUrl(showQr)}
                                inner={t("store.check_payment")}
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <div className="p-3">
                <img src="/media/payment.svg" />
            </div>
        </div>
    );
}

export default Payment;
